// removed by extract-text-webpack-plugin
module.exports = {"wrap":"_6ii3COjYbFAnL0fvL87C0","info":"_3PhIDfddH_ARAxNQbM1CjT","detail":"sZcsoJBAfo6vudSDianb0","stack":"_2oNuE69s2oZViq83rsyfdP"};


//////////////////
// WEBPACK FOOTER
// ./src/container/noMatch.module.css
// module id = 826
// module chunks = 0